module.exports = __webpack_public_path__ + "static/images/styles/images/landing-bg.ffc378eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing-bg.jpg
// module id = 3648
// module chunks = 11